import { FC } from 'react';
import { ItemProps } from '../../types';


import Text from './Text';
import LongText from './LongText';
import Code from './Code';
import Checkbox from './Checkbox';
import File from './File';
import Select from './Select';
import Number from './Number';
import Group from './Group';
import Preview from './Preview';
import Range from './Range';
import Divider from './Divider';
import Button from './Button';
import Password from './Password';
import Switch from './Switch';
import Label from './Label';


type ElementsType = {
    [key: string]: FC<ItemProps>;
};

const elements: ElementsType = {
    Text,
    LongText,
    Code,
    Checkbox,
    File,
    Select,
    Number,
    Group,
    Preview,
    Range,
    Divider,
    Button,
    Password,
    Switch,
    Label
};

export default elements;
